export const realTimeEligibilityDocumentation = `
# Real-Time Eligibility Check

## Overview

The Real-Time Eligibility block allows you to fetch real-time eligibility data
for a particular patient and their insurance.

## How to Use

The block requires both the Patient Insurance Information ID and the National Provider Identifier (NPI). It
uses this information to retrieve the patients insurance information and then
call the Availity RTE API to get the eligibility status of the patient.

The block returns the data straight from the Availity API.

Availity payer list UI:
https://essentials.availity.com/static/public/onb/onboarding-ui-apps/payer-list-ui/#/

National Provider Identifier (NPI) registry (used it to look up the NPI being used in the query):
https://npiregistry.cms.hhs.gov/search
`;
